export function SettingDisplay(props) {
    const label = props.value + props.text;
    return (
        <div className="custom-setting">
            <span className="custom-setting-label">
                {label.charAt(0).toUpperCase() + label.slice(1)}
            </span>
        </div>
    );
}